import * as React from 'react'
import { useEffect, useRef, useState } from 'react'
import { Input, Icon } from '../../../shared'
import { type FilterTypes, filterBarStore, filterBarStore as store } from '../filter-bar.store'
import { CollectionSort } from '../../../collections'
import ProductMetafieldFilter from '../../product-filter/product-filter-type.component'
import './filter-bar-mobile.scss'
import { observer } from 'mobx-react'

const FilterBarMobile: React.FC = observer(() => {
  const [searchActive, setSearchActive] = useState(false)
  const divRef = useRef<HTMLDivElement>(null)
  const searchBarRef = useRef<Input>(null)

  const capitalize = (str: string) => {
    if (typeof str !== 'string' || str.length === 0) {
      return str
    }

    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  const handleDocumentClick = (event: Event) => {
    const { current: divRefCurrent } = divRef
    if (divRefCurrent && !divRefCurrent.contains(event.target as Element)) {
      setSearchActive(false)
    }
  }

  const toggleMobileSearch = () => {
    setSearchActive(!searchActive)
    if (!searchActive) {
      const { current: searchBarRefCurrent } = searchBarRef
      if (searchBarRefCurrent) {
        const { current: inputRef } = searchBarRefCurrent.inputRef
        if (inputRef) {
          inputRef.focus()
        }
      }
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick, false)
    return () => {
      document.removeEventListener('click', handleDocumentClick, false)
    }
  }, [])

  const shouldDisplaySelectedFilters = Object.values(filterBarStore.selectedFiltersV2).some((filter) => filter.length > 0)

  return (
    <div className='filter-bar-mobile' ref={divRef}>
      <div className='filter-bar-mobile__container'>
        <ProductMetafieldFilter type='preference' />
        <ProductMetafieldFilter type='protein' />
        <ProductMetafieldFilter type='cuisine' />
        <ProductMetafieldFilter type='dietary_preferences' /> 

        <div className='filter-bar-mobile__col'>
          <CollectionSort />
        </div>

        {searchActive && (
          <div className={`filter-bar-mobile__search-bar search-bar__mobile ${searchActive ? 'dropdown' : ''}`}>
            <Input
              ref={searchBarRef}
              type='text'
              placeholder='Search the menu...'
              classNames='filter-bar-mobile__search-bar__inner'
              onChange={store.handleSearchFilter}
            />
          </div>
        )}

        <div className='filter-bar-mobile__col filter-bar-mobile__col--right'>
          <div className='filter-bar-mobile__search-button pointer' onClick={toggleMobileSearch}>
            <Icon icon={`${searchActive ? 'cross-circled-filled' : 'search'}`} className='filter-bar-mobile__icon' />
          </div>
        </div>
      </div>

      {shouldDisplaySelectedFilters && (
        <div className='filter-bar-display-options'>
          {Object.entries(filterBarStore.selectedFiltersV2).map(([type, filters]) => {
            if (filters.length > 0) {
              return filters.map((filter: string) => (
                <span key={filter} className='filter-bar-display-options__item'>
                  {`${capitalize(type)}: ${filter}`}
                  <span className='close' onClick={() => filterBarStore.removeSelectedFilter(type as keyof FilterTypes, filter)}>
                    &#10005;
                  </span> 
                </span>
              )) 
            }
          })}
          <span className='remove-all' onClick={() => filterBarStore.resetSelectedFiltersV2()}>
            Remove all
          </span>
        </div>
      )}
    </div>
  )
})

export default FilterBarMobile
